const RightBarInitialState = {
  toggleState: 0,
  dockOrder: [] as string[],
  selectedId: null as string | null,
};
export default RightBarInitialState;
